module.exports = __webpack_public_path__ + "static/more-green-space_the-power-of-verbal-art-project-installation-2024add5249bfb9187aeeb6e0bd93b62.jpg";